import { Button } from "../components/ui/button";
import { Link } from "../components/ui/link";

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto py-12 px-4 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8">Terms of Use</h1>
        <div className="prose dark:prose-invert max-w-none space-y-8">
          <section>
            <p className="text-muted-foreground">Last updated: 15.12.2024</p>
            <p className="text-lg mt-4">
              Please read these Terms of Use carefully before using PentAGI. By
              accessing or using the software, you agree to be bound by these
              terms and conditions.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Legal Agreement</h2>
            <div className="bg-destructive/10 border border-destructive/20 rounded-lg p-6 mb-6">
              <p className="font-medium text-destructive mb-4">
                Important Notice:
              </p>
              <ul className="list-disc list-inside space-y-4 ml-4">
                <li className="pl-2">
                  By using PentAGI, you enter into a legally binding agreement
                  with its creators and maintainers
                </li>
                <li className="pl-2">
                  If you do not agree with any part of these terms, you must not
                  use the software
                </li>
                <li className="pl-2">
                  Violation of these terms may result in immediate termination
                  of your right to use PentAGI
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Acceptable Use</h2>
            <p className="mb-4">You agree to use PentAGI only:</p>
            <ul className="list-disc list-inside space-y-4 mb-4 ml-4">
              <li className="pl-2">
                In compliance with all applicable laws and regulations
              </li>
              <li className="pl-2">
                With explicit written authorization from system owners
              </li>
              <li className="pl-2">
                For legitimate security testing and educational purposes
              </li>
              <li className="pl-2">
                In accordance with ethical hacking principles and best practices
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              Intellectual Property
            </h2>
            <div className="bg-muted rounded-lg p-6">
              <ul className="space-y-4">
                <li className="pl-2">
                  ✓ PentAGI and its original content remain the exclusive
                  property of its creators
                </li>
                <li className="pl-2">
                  ✓ The software is protected by copyright and other
                  intellectual property laws
                </li>
                <li className="pl-2">
                  ✓ Users receive a limited, non-exclusive license to use the
                  software
                </li>
                <li className="pl-2">
                  ✓ Modifications and contributions are subject to the project's
                  licensing terms
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              Liability and Warranty
            </h2>
            <div className="bg-muted/50 rounded-lg p-6">
              <p className="mb-4">
                The software is provided "AS IS", without warranty:
              </p>
              <ul className="list-disc list-inside space-y-4 ml-4">
                <li className="pl-2">
                  No warranty of merchantability or fitness for a particular
                  purpose
                </li>
                <li className="pl-2">
                  No liability for damages arising from the use of the software
                </li>
                <li className="pl-2">
                  Users assume all risks associated with using PentAGI
                </li>
                <li className="pl-2">
                  No guarantee of continuous, uninterrupted, or secure access
                </li>
              </ul>
            </div>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">
              Third-Party Services
            </h2>
            <p>
              When using integrated third-party services (OpenAI, Anthropic,
              search engines), you agree to:
            </p>
            <ul className="list-disc list-inside space-y-4 mb-4 ml-4">
              <li className="pl-2">
                Comply with their respective terms of service
              </li>
              <li className="pl-2">
                Accept their data handling and privacy policies
              </li>
              <li className="pl-2">
                Be responsible for any costs or fees associated with their use
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Termination</h2>
            <p className="mb-4">
              We reserve the right to terminate or suspend access to PentAGI:
            </p>
            <ul className="list-disc list-inside space-y-4 mb-4 ml-4">
              <li className="pl-2">Without prior notice or liability</li>
              <li className="pl-2">For any violation of these Terms of Use</li>
              <li className="pl-2">
                For any unlawful or harmful use of the software
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Changes to Terms</h2>
            <p>
              We may modify these terms at our discretion. Significant changes
              will be announced through the project repository. Continued use of
              PentAGI after changes constitutes acceptance of the modified
              terms.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-4">Contact</h2>
            <p>
              For questions about these Terms of Use:{" "}
              <a
                href="mailto:info@pentagi.com"
                className="text-primary hover:underline"
              >
                info@pentagi.com
              </a>
            </p>
          </section>
        </div>

        <div className="mt-12 flex justify-between items-center">
          <Button asChild variant="outline">
            <Link href="/">← Back to Home</Link>
          </Button>
          <Button asChild variant="default">
            <a
              href="https://github.com/vxcontrol/pentagi"
              target="_blank"
              rel="noopener noreferrer"
            >
              Project Repository →
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
}
